module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_6000.4550771b.png";